(function () {
  const MOBILE = window.matchMedia("(max-width: 960px)");
  const OPEN_CLASS = "is-open";

  let lastMobile = MOBILE.matches;
  let resizeTimer;

  function getDirectSubmenu(item) {
    return item.querySelector(":scope > ul.drawer-menu__list--sub");
  }

  function getDirectTrigger(item) {
    return item.querySelector(
      ':scope > a.drawer-menu__link[data-item="parent"]',
    );
  }

  /** Strip inline heights from theme drill-down so flex + .drawer-menu__contents can scroll. */
  function unlockDrawerHeights(root) {
    if (!root) return;

    const main = root.querySelector("[data-main]");
    const allLinks = root.querySelector(".drawer-menu__all-links");
    const wrappers = root.querySelectorAll(".drawer-menu__links-wrapper");
    const bottom = root.querySelector(".drawer-menu__bottom");

    const clear = (el) => {
      if (!el) return;
      el.style.removeProperty("height");
      el.style.removeProperty("max-height");
    };

    clear(main);
    clear(bottom);
    clear(allLinks);
    wrappers.forEach(clear);
  }

  function updateAncestorHeights(fromItem) {
    let current = fromItem;

    while (current) {
      const parentSubmenu = current.closest("ul.drawer-menu__list--sub");
      if (!parentSubmenu) break;

      const parentItem = parentSubmenu.closest("li.drawer-menu__item");
      if (!parentItem || !parentItem.classList.contains(OPEN_CLASS)) break;

      parentSubmenu.style.maxHeight = parentSubmenu.scrollHeight + "px";
      current = parentItem;
    }
  }

  function animateOpen(submenu) {
    submenu.style.maxHeight = "0px";
    requestAnimationFrame(() => {
      submenu.style.maxHeight = submenu.scrollHeight + "px";
    });
  }

  function animateClose(submenu) {
    submenu.style.maxHeight = submenu.scrollHeight + "px";
    requestAnimationFrame(() => {
      submenu.style.maxHeight = "0px";
    });
  }

  function closeItem(item) {
    item.classList.remove(OPEN_CLASS);

    const trigger = getDirectTrigger(item);
    const submenu = getDirectSubmenu(item);

    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (!submenu) return;

    submenu.setAttribute("aria-hidden", "true");
    animateClose(submenu);
  }

  /** Instant collapse (no transition) — used when the drawer closes so reopen starts at the top level. */
  function resetAccordionState(root) {
    if (!root) return;
    root.querySelectorAll(".has-accordion-children.is-open").forEach((item) => {
      item.classList.remove(OPEN_CLASS);
      const trigger = getDirectTrigger(item);
      const submenu = getDirectSubmenu(item);
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (submenu) {
        submenu.setAttribute("aria-hidden", "true");
        submenu.style.maxHeight = "0px";
      }
    });
    unlockDrawerHeights(root);
  }

  function watchDrawerClose(root) {
    if (!root || root.dataset.accordionDrawerWatch === "true") return;
    root.dataset.accordionDrawerWatch = "true";

    let wasActive = root.classList.contains("active");

    const observer = new MutationObserver(() => {
      if (!MOBILE.matches) {
        wasActive = root.classList.contains("active");
        return;
      }
      const isActive = root.classList.contains("active");
      if (wasActive && !isActive) {
        resetAccordionState(root);
      }
      wasActive = isActive;
    });

    observer.observe(root, { attributes: true, attributeFilter: ["class"] });
  }

  function openItem(item) {
    item.classList.add(OPEN_CLASS);

    const trigger = getDirectTrigger(item);
    const submenu = getDirectSubmenu(item);

    if (trigger) trigger.setAttribute("aria-expanded", "true");
    if (!submenu) return;

    submenu.setAttribute("aria-hidden", "false");
    animateOpen(submenu);
    updateAncestorHeights(item);
  }

  function bindAccordion(root) {
    if (!root || root.dataset.accordionReady === "true") return;
    root.dataset.accordionReady = "true";
    root.classList.add("drawer-menu--accordion");

    watchDrawerClose(root);
    unlockDrawerHeights(root);

    const parentLinks = root.querySelectorAll(
      'a.drawer-menu__link[data-item="parent"]',
    );

    parentLinks.forEach((link) => {
      const item = link.closest("li.drawer-menu__item");
      if (!item) return;

      const submenu = getDirectSubmenu(item);
      if (!submenu) return;

      item.classList.add("has-accordion-children");
      link.classList.add("accordion-trigger");
      link.setAttribute("aria-expanded", "false");
      submenu.setAttribute("aria-hidden", "true");
      submenu.style.maxHeight = "0px";

      submenu.addEventListener("transitionend", (e) => {
        if (e.target !== submenu) return;
        if (e.propertyName !== "max-height") return;

        if (item.classList.contains(OPEN_CLASS)) {
          submenu.style.removeProperty("max-height");
          updateAncestorHeights(item);
        } else {
          submenu.style.maxHeight = "0px";
        }
      });

      link.addEventListener(
        "click",
        function (e) {
          if (!MOBILE.matches) return;

          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();

          const willOpen = !item.classList.contains(OPEN_CLASS);

          const siblings = item.parentElement
            ? Array.from(item.parentElement.children)
            : [];
          siblings.forEach((sib) => {
            if (
              sib !== item &&
              sib.classList &&
              sib.classList.contains(OPEN_CLASS)
            ) {
              closeItem(sib);
            }
          });

          if (willOpen) openItem(item);
          else closeItem(item);

          unlockDrawerHeights(root);
          updateAncestorHeights(item);
        },
        true,
      );
    });
  }

  function initAll() {
    const now = MOBILE.matches;
    if (now !== lastMobile) lastMobile = now;
    if (!MOBILE.matches) return;
    document
      .querySelectorAll(".drawer-menu[data-drawer-menu]")
      .forEach(bindAccordion);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  window.addEventListener("load", initAll);
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:reorder", initAll);
  document.addEventListener("click", initAll, true);

  const mo = new MutationObserver(() => initAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const now = MOBILE.matches;
      if (now !== lastMobile) {
        lastMobile = now;
        initAll();
      }

      document
        .querySelectorAll(
          ".drawer-menu--accordion .has-accordion-children.is-open > ul.drawer-menu__list--sub",
        )
        .forEach((sub) => {
          sub.style.maxHeight = sub.scrollHeight + "px";
        });

      document
        .querySelectorAll(".drawer-menu[data-drawer-menu]")
        .forEach(unlockDrawerHeights);
    }, 150);
  });
})();
